import { observable, action, computed } from 'mobx'

class WidgetStore {
  @observable _unrecoverableError = false

  constructor({ host, apiKey }) {
    this.host = host
    this.apiKey = apiKey
  }

  @computed get unrecoverableError() {
    return this._unrecoverableError
  }

  set unrecoverableError(error) {
    this._unrecoverableError = true
    console.error(error)
  }
}

export default WidgetStore
